import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SessionService } from "../services/session.service";

const auditTrailColumnDefinitions = [
  ["Date&Time", "Date & Time", "60"],
  ["FieldName", "Field Name", "100px"],
  ["OriginalValue", "Original Value", "60px"],
  ["NewValue", "New Value", "60px"],
  ["Action", "Action", "80px"],
  ["User", "User", "100px"],
] as const;

@Component({
    selector: "app-audit-trail",
    templateUrl: "./audit-trail.component.html",
    styleUrls: ["./audit-trail.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuditTrailComponent implements OnInit {
  public sampleColumns: any;
  @Input() auditTrailList: any;
  @Input() sessionID: any;

  constructor(public _sessionService: SessionService) {
    this.auditTrailList = [];
    this.sampleColumns = [];
  }

  ngOnInit() {
    this.setColumnHeading();
  }

  setColumnHeading() {
    this.sampleColumns = auditTrailColumnDefinitions.map(([name, header, minWidth]) => ({
      name,
      header,
      dataType: "string",
      minWidth,
    }));
  }

  exportReport() {
    this._sessionService
      .exportAuditTrailReport(this.sessionID)
      .subscribe((res) => {
        const binaryData = [];
        binaryData.push(res);
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/vnd.ms-excel" })
        );

        // create hidden dom element (so it works in all browsers)
        const a = document.createElement("a");
        a.setAttribute("style", "display:none;");
        document.body.appendChild(a);
        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = "AuditTrailExportReport.xls";
        a.click();
      });
  }
}
